import styled from 'styled-components';
import { Color } from 'modules/styles/colors';
import { MuiBox, MuiButton, MuiTypography } from 'theme/material-ui';

export interface CalcHeightProps {
  totalCards: number;
  windowWidth: number;
  visibleSlides: number;
}

interface CardContainerProps extends CalcHeightProps {
  backgroundColor: string;
}

interface CardDimensions {
  leftWidth: string;
  leftTextWidth: string;
  subTitleWidth: string;
  leftBtnWidth: string;
  height: string;
  leftSpace: string;
  rightSpace: string;
  smallText: string;
  largeText: string;
  lgTxtLineHeight: string;
  subText: string;
  btnText: string;
}

const sharedSingleCardDimensions = {
  '768': {
    leftWidth: '320px',
    leftTextWidth: '260px',
    subTitleWidth: '260px',
    leftBtnWidth: '75%',
    height: '245px',
    leftSpace: '8%',
    rightSpace: '5%',
    smallText: '14px',
    largeText: '20px',
    lgTxtLineHeight: '28px',
    subText: '14px',
    btnText: '14px'
  },
  '600': {
    leftWidth: '280px',
    leftTextWidth: '220px',
    subTitleWidth: '220px',
    leftBtnWidth: '50%',
    height: '220px',
    leftSpace: '5%',
    rightSpace: '5%',
    smallText: '14px',
    largeText: '18px',
    lgTxtLineHeight: '26px',
    subText: '14px',
    btnText: '12px'
  },
  '>480': {
    leftWidth: '280px',
    leftTextWidth: '220px',
    subTitleWidth: '160px',
    leftBtnWidth: '50%',
    height: '220px',
    leftSpace: '2%',
    rightSpace: '-1%',
    smallText: '12px',
    largeText: '18px',
    lgTxtLineHeight: '24px',
    subText: '12px',
    btnText: '12px'
  },
  '<480': {
    leftWidth: '220px',
    leftTextWidth: '150px',
    subTitleWidth: '150px',
    leftBtnWidth: '50%',
    height: '200px',
    leftSpace: '5%',
    rightSpace: '-5%',
    smallText: '12px',
    largeText: '14px',
    lgTxtLineHeight: '22px',
    subText: '12px',
    btnText: '12px'
  }
};

export const calcCardDimensions = (props: CalcHeightProps): CardDimensions => {
  if (props.totalCards === 1) {
    if (props.windowWidth > 1440)
      return {
        leftWidth: '450px',
        leftTextWidth: '400px',
        subTitleWidth: '400px',
        leftBtnWidth: '65%',
        height: '300px',
        leftSpace: '9%',
        rightSpace: '9%',
        smallText: '16px',
        largeText: '34px',
        lgTxtLineHeight: '40px',
        subText: '16px',
        btnText: '16px'
      };
    if (props.windowWidth > 960)
      return {
        leftWidth: '380px',
        leftTextWidth: '310px',
        subTitleWidth: '310px',
        leftBtnWidth: '65%',
        height: '280px',
        leftSpace: '10%',
        rightSpace: '10%',
        smallText: '16px',
        largeText: '28px',
        lgTxtLineHeight: '35px',
        subText: '16px',
        btnText: '14px'
      };
    if (props.windowWidth > 768) return sharedSingleCardDimensions[768];
    if (props.windowWidth > 600) return sharedSingleCardDimensions[600];
    if (props.windowWidth > 480) return sharedSingleCardDimensions['>480'];
    if (props.windowWidth < 480) return sharedSingleCardDimensions['<480'];
  } else if (props.totalCards > 1) {
    if (props.visibleSlides === 1) {
      if (props.windowWidth > 768) return sharedSingleCardDimensions[768];
      if (props.windowWidth > 600) return sharedSingleCardDimensions[600];
      if (props.windowWidth > 480) return sharedSingleCardDimensions['>480'];
      if (props.windowWidth < 480) return sharedSingleCardDimensions['<480'];
    }
    if (props.visibleSlides === 2) {
      if (props.windowWidth > 1400)
        return {
          leftWidth: '360px',
          leftTextWidth: '210px',
          subTitleWidth: '210px',
          leftBtnWidth: '55%',
          height: '225px',
          leftSpace: '6%',
          rightSpace: '6%',
          smallText: '14px',
          largeText: '18px',
          lgTxtLineHeight: '24px',
          subText: '14px',
          btnText: '12px'
        };
      if (props.windowWidth > 1200)
        return {
          leftWidth: '360px',
          leftTextWidth: '210px',
          subTitleWidth: '210px',
          leftBtnWidth: '55%',
          height: '225px',
          leftSpace: '4%',
          rightSpace: '1%',
          smallText: '14px',
          largeText: '18px',
          lgTxtLineHeight: '24px',
          subText: '14px',
          btnText: '12px'
        };
    }
    if (props.visibleSlides === 3) {
      if (props.windowWidth > 1600)
        return {
          leftWidth: '280px',
          leftTextWidth: '200px',
          subTitleWidth: '200px',
          leftBtnWidth: '65%',
          height: '225px',
          leftSpace: '4%',
          rightSpace: '3%',
          smallText: '14px',
          largeText: '20px',
          lgTxtLineHeight: '22px',
          subText: '14px',
          btnText: '12px'
        };
      if (props.windowWidth > 1500)
        return {
          leftWidth: '280px',
          leftTextWidth: '200px',
          subTitleWidth: '200px',
          leftBtnWidth: '65%',
          height: '225px',
          leftSpace: '2%',
          rightSpace: '-7%',
          smallText: '14px',
          largeText: '20px',
          lgTxtLineHeight: '22px',
          subText: '14px',
          btnText: '12px'
        };
    }
  }
  return {
    leftWidth: '280px',
    leftTextWidth: '200px',
    subTitleWidth: '200px',
    leftBtnWidth: '80%',
    height: '245px',
    leftSpace: '2%',
    rightSpace: '2%',
    smallText: '16px',
    largeText: '20px',
    lgTxtLineHeight: '22px',
    subText: '16px',
    btnText: '12px'
  };
};

export const CardContainerBlank = styled(MuiBox)`
  border-radius: 5px;
  height: ${(props: CalcHeightProps) => calcCardDimensions(props).height};
  width: 100%;
  overflow: hidden;
`;

export const CardContainer = styled(MuiBox)`
  position: relative;
  border-radius: 5px;
  width: 100%;
  height: ${(props: CardContainerProps) => calcCardDimensions(props).height};
  background-color: ${(props: CardContainerProps) => props.backgroundColor || 'white'};
  overflow: hidden;
`;

export const ContentLeft = styled(MuiBox)`
  position: absolute;
  left: ${(props: CalcHeightProps) => calcCardDimensions(props).leftSpace};
  width: ${(props: CalcHeightProps) => calcCardDimensions(props).leftWidth};
  height: ${(props: CalcHeightProps) => calcCardDimensions(props).height};
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ContentRight = styled(MuiBox)`
  position: absolute;
  height: ${(props: CalcHeightProps) => calcCardDimensions(props).height};
  right: ${(props: CalcHeightProps) => calcCardDimensions(props).rightSpace};
  z-index: 1;
`;

export const TextContentContainer = styled(MuiBox)`
  width: ${(props: CalcHeightProps) => calcCardDimensions(props).leftTextWidth};
`;

export const SmallTitle = styled(MuiTypography)`
  font-size: ${(props: CalcHeightProps) => calcCardDimensions(props).smallText} !important;
`;

export const LargeTitle = styled(MuiTypography)`
  font-size: ${(props: CalcHeightProps) => calcCardDimensions(props).largeText} !important;
  line-height: ${(props: CalcHeightProps) => calcCardDimensions(props).lgTxtLineHeight} !important;
`;

export const SubTitle = styled(MuiTypography)`
  font-size: ${(props: CalcHeightProps) => calcCardDimensions(props).subText} !important;
  width: ${(props: CalcHeightProps) => calcCardDimensions(props).subTitleWidth};
`;

export const LeftBtnContainer = styled(MuiBox)`
  width: ${(props: CalcHeightProps) => calcCardDimensions(props).leftBtnWidth};
  padding-bottom: 20px;
`;

export const ActionButtonOne = styled(MuiButton)`
  .MuiButton-label {
    font-size: ${(props: CalcHeightProps) => calcCardDimensions(props).btnText};
    color: ${Color.primary};
  }
  && {
    &.MuiButton-root {
      border: none;
      box-shadow: none;
    }
    &.MuiButton-contained {
      background-color: ${Color.white};
      color: ${Color.primary};
    }
  }
`;

export const ActionButtonTwo = styled(MuiButton)`
  .MuiButton-label {
    font-size: ${(props: CalcHeightProps) => calcCardDimensions(props).btnText};
  }
`;

export const ActionButtonTwoSpace = styled(MuiBox)`
  height: 33px;
`;

export const StyledImage = styled.img`
  width: ${(props: CalcHeightProps) => calcCardDimensions(props).height};
  height: ${(props: CalcHeightProps) => calcCardDimensions(props).height};
`;

export const FlippableCardContainer = styled(MuiBox)`
  background-color: transparent;
  perspective: 1000px;
`;

export const FlippableInner = styled(MuiBox)`
  width: 100%;
  height: ${(props: CalcHeightProps) => calcCardDimensions(props).height};
  position: relative;
  transition: transform 0.3s;
  transform-style: preserve-3d;
`;

// @Note: flip animation will be revisited in phase two
export const FlippableFront = styled(MuiBox)`
  position: absolute;
  width: 100%;
  height: ${(props: CalcHeightProps) => calcCardDimensions(props).height};
  --webkit-backface-visibility: hidden;
  --moz-backface-visibility: hidden;
  backface-visibility: hidden;
  background-color: white;
`;

export const FlippableBack = styled(MuiBox)`
  position: absolute;
  width: 100%;
  height: ${(props: CalcHeightProps) => calcCardDimensions(props).height};
  --webkit-backface-visibility: hidden;
  --moz-backface-visibility: hidden;
  backface-visibility: hidden;
  transform: rotateY(180deg);
  background-color: white;
`;
